import { render } from "./ASDespreNoi.vue?vue&type=template&id=8a380b1a&scoped=true"
import script from "./ASDespreNoi.vue?vue&type=script&lang=js"
export * from "./ASDespreNoi.vue?vue&type=script&lang=js"

import "./ASDespreNoi.vue?vue&type=style&index=0&id=8a380b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a380b1a"]])

export default __exports__